import React, { FC } from 'react'

// Callouts
import Prefooter from "@components/Prefooter/Prefooter"
import DefaultPrefooter from '@components/prefooters/DefaultPrefooter/DefaultPrefooter'
import { PostTemplatePostFragmentFragment } from '@graphqlTypes'

export enum POST_FOOTER_STYLES {
  DEFAULT = 'DEFAULT',
  DOWNLOAD = 'DOWNLOAD',
  SUBSCRIBE = 'SUBSCRIBE',
  TRIAL = 'TRIAL',
}

const PostFooter: FC<{
  footerStyle?: POST_FOOTER_STYLES
  pdfLink?: PostTemplatePostFragmentFragment["prefooterPdfLink"]
  title?: PostTemplatePostFragmentFragment["title"]
}> = ({
  footerStyle = POST_FOOTER_STYLES.DEFAULT,
  pdfLink,
  title,
}) => {
    if (pdfLink && footerStyle === POST_FOOTER_STYLES.DOWNLOAD) {
      return (
        <Prefooter
          title={title}
          formRedirectUrl={pdfLink}
        />
      )
    }

    return (
      <DefaultPrefooter />
    )
  }

export default PostFooter
